import { FooterBox, Text } from './Footer.style';

const Footer = () => {
    return (
        <div>
            <FooterBox>
                <Text>©Mt.EB Rainbow. All rights Reserved.</Text>
                <Text>Contact | mt.ebrainbow@gmail.com</Text>
            </FooterBox>
        </div>
    );
};
export default Footer;
